import React, { useState } from 'react';
import TableCell from '@mui/material/TableCell';
import { styled, alpha } from '@mui/material/styles';
import {
  IconButton,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import EditAttendance from '../EditAttendance';
import AppTableContainer from '@projectK/components/AppTableContainer';
import AppScrollbar from '@projectK/components/AppScrollbar';
import { Fonts } from '@projectK/constants';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import FormatCreatedAtDate from '@projectK/modules/apps/DateFormat';
import PropTypes from 'prop-types';
import { useSwitchBack } from "@projectK/hooks/SwitchBackHelper";
import { isStudent, isParent,hasPermission,useRolePermissions } from '@projectK/context/RolesProvider';
import AppTableLoader from '@projectK/components/AppTableLoader';
import AppTableNoData from '@projectK/components/AppTableNoData';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 14,
  padding: 8,
  '&:first-of-type': {
    paddingLeft: 20,
  },
  '&:last-of-type': {
    paddingRight: 20,
  },
  '& .icon-btn': {
    border: `solid 1px ${alpha('#F84E4E', 1.0)}`,
    color: alpha('#F84E4E', 1.0),
    padding: 3,
    fontSize: 20,
    '&:not(:first-of-type)': {
      marginLeft: 8,
    },
  },
  '& .icon-btn-eye': {
    border: `solid 1px ${alpha(theme.palette.primary.main, 1.0)}`,
    color: alpha(theme.palette.primary.main, 1.0),
  },
  '&:hover': {
    '& .icon-btn': {
      border: `solid 1px #F84E4E`,
      color: '#F84E4E',
    },
    '& .icon-btn-eye': {
      border: `solid 1px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
  },
}));

const AttendanceTable = ({
  activitySessionData,
  reportFields,
  attendanceData,
  sessionId,
  reportName,
  fetchAttendanceData,
  onDelete,
  handleReportsData,
  loading,
  exportLoading,
}) => {
  const [editItemId, setEditItemId] = useState(null);
const { rolePermissions } = useRolePermissions();
  const handleEditClick = (id) => {
    setEditItemId(id);
  };

  const handleCloseEditModal = () => {
    setEditItemId(null);
  };
  const sortedAttendanceData = attendanceData.map((data) => ({
    ...data,
    firstName: data.firstName.charAt(0).toUpperCase() + data.firstName.slice(1),
    email: data.email.charAt(0).toUpperCase() + data.email.slice(1),
  }));

  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [userFeedBack, setUserFeedBack] = useState(null);
  const [userReportId, setUserReportId] = useState(null);
  const { switchBack, DialogRenderer } = useSwitchBack();
  const { user } = useAuthUser();
  const handleDelete = (itemId, feedBack, user_reportId) => {
    setItemToDelete(itemId);
    setUserFeedBack(feedBack);
    setUserReportId(user_reportId);
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = () => {
    onDelete(itemToDelete, userFeedBack, userReportId);
    setDeleteConfirmationOpen(false);
  };

  const handleCancelDelete = () => {
    setDeleteConfirmationOpen(false);
  };

  const fieldsNames =
    sortedAttendanceData.length > 0
      ? sortedAttendanceData[0].report_field_name
      : [];
  return (
    <>
    <AppTableContainer className="app-table-container">
     <AppTableLoader loading={loading || exportLoading} className={'app-table-loader'}/> 
        <AppScrollbar className='edit-ses-attend max-h'>
          <Table stickyHeader>
            <TableHead
              sx={{
                borderBottom: '0 none',
                '& .tableCell': {
                  fontSize: 13,
                  padding: 2,
                  fontWeight: Fonts.BOLD,
                  backgroundColor: '#fff',
                  color: '#000',
                  '&:first-of-type': {
                    pl: 5,
                  },
                  '&:last-of-type': {
                    pr: 5,
                  },
                },
              }}
            >
              <TableRow>
                <TableCell className='tableCell' align='left'>
                  First Name
                </TableCell>
                <TableCell className='tableCell'>Email</TableCell>
                <TableCell className='tableCell'>Created At</TableCell>
                {fieldsNames?.map((fieldName, index) => (
                  <TableCell key={index+0} className='tableCell' align='center'>
                    {fieldName}
                  </TableCell>
                ))}
                <TableCell className='tableCell' align='center'>
                  Attendance
                </TableCell>
                <TableCell className='tableCell' align='center'>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* {sortedAttendanceData.length > 0 && */}
              {sortedAttendanceData.length > 0 ? (
                sortedAttendanceData.map((item) => (
                  <TableRow className='item-hover' key={item.id}>
                    <StyledTableCell
                      align='left'
                      sx={{ textTransform: 'capitalize' }}
                      onClick={() => {
                        const userRole = { roleMenuFlag: item.role_menu_flag };
                        // Check the condition before calling onSwitchRole
                        if (
                          user.id !== item.user_id &&
                          item?.role_names?.length === 1 &&
                          (isParent(userRole) || isStudent(userRole))
                        ) {
                          switchBack({
                            id: item.user_id,
                            actualRole: user?.roleIds[0],
                            role: item.role_ids[0],
                            actualUser: user.id,
                            openInBlankWindow: true,
                          });
                        }
                      }}
                      style={{
                        cursor: (() => {
                          const userRole = { roleMenuFlag: item.role_menu_flag };
                          return user.id !== item.user_id &&
                            item?.role_names?.length === 1 &&
                            (isParent(userRole) || isStudent(userRole))
                            ? 'pointer'
                            : 'auto';
                        })(),
                      }}
                    >
                      <Box className='textwrap1'>
                        {item.firstName} {item.lastName}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell align='left'>
                      <Box className='textwrap1'>{item.email}</Box>
                    </StyledTableCell>
                    <StyledTableCell align='left'>
                      <FormatCreatedAtDate
                        date={item?.created_at}
                        showTime={false}
                        showDate={true}
                        showDay={true}
                      />
                    </StyledTableCell>
                    {fieldsNames?.map((fieldName) => (
                      <TableCell
                        key={fieldName}
                        className='tableCell'
                        align='center'
                      >
                        {item[fieldName] === '' ? '-' : item[fieldName]}
                      </TableCell>
                    ))}
                    <StyledTableCell align='center'>
                      {item.is_attended === 1 ? 'True' : 'False'}
                    </StyledTableCell>
                    <StyledTableCell align='center'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {hasPermission(
                          rolePermissions,
                          'Member Information - Attendance Report',
                          'update',
                        ) && (
                          <IconButton
                            size='small'
                            className='icon-btn icon-btn-eye'
                            onClick={() => handleEditClick(item.id)}
                          >
                            <AiOutlineEdit />
                          </IconButton>
                        )}
                        {hasPermission(
                          rolePermissions,
                          'Member Information - Attendance Report',
                          'delete',
                        ) && (
                          <IconButton
                            size='small'
                            className='icon-btn'
                            onClick={() =>
                              handleDelete(
                                item.id,
                                item.user_feedback_id,
                                item.userReportId,
                              )
                            }
                          >
                            <AiOutlineDelete />
                          </IconButton>
                        )}
                      </div>
                    </StyledTableCell>
                    {itemToDelete === item.id && (
                      <Dialog
                        open={deleteConfirmationOpen}
                        onClose={handleCancelDelete}
                        // fullWidth
                        maxWidth='xs'
                      >
                        <DialogTitle>
                          <Typography variant='h4'>Confirm Deletion</Typography>
                        </DialogTitle>
                        <DialogContent>
                          <Typography
                            sx={{ fontSize: '16px', fontWeight: 'bold' }}
                          >
                            Are you sure you want to delete this attendance?
                          </Typography>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleConfirmDelete} color='primary'>
                            Yes
                          </Button>
                          <Button
                            onClick={handleCancelDelete}
                            color='secondary'
                          >
                            No
                          </Button>
                        </DialogActions>
                      </Dialog>
                    )}
                    {editItemId === item.id && (
                      <EditAttendance
                        isOpen={editItemId === item.id}
                        onClose={handleCloseEditModal}
                        activitySessionData={activitySessionData}
                        reportName={reportName}
                        attendanceData={item}
                        studentId={item.user_id}
                        sessionId={sessionId}
                        fetchAttendanceData={fetchAttendanceData}
                        reportFields={reportFields}
                        handleReportsData={handleReportsData}
                      />
                    )}
                  </TableRow>
                ))
               ) : (
                <AppTableNoData
                  colSpan={5}
                  message="No Attendence Found"
                  loading={loading}
                 />
              )}
            </TableBody>
          </Table>
        </AppScrollbar>
      </AppTableContainer>
      <DialogRenderer />
    </>
  );
};
export default AttendanceTable;

AttendanceTable.propTypes = {
  activitySessionData: PropTypes.object, // Details of the session (time, name, etc.)
  reportFields: PropTypes.arrayOf(PropTypes.string), // List of report field names
  attendanceData: PropTypes.arrayOf(PropTypes.object), // Raw attendance records for the session
  sessionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Unique ID of the session
  reportName: PropTypes.string, // Name/title of the report
  fetchAttendanceData: PropTypes.func, // Function to re-fetch attendance records
  handleReportsData: PropTypes.func, // Function to process/transform report data
  onDelete: PropTypes.func, // Function to process/transform report data
  loading: PropTypes.bool,
  exportLoading: PropTypes.bool,
};
